import React, { useEffect, useState } from 'react'
import { ReactComponent as Mail } from '@/shared/assets/mail.svg'
import { ReactComponent as Globe } from '@/shared/assets/globe.svg'
import { ReactComponent as Circles } from '@/shared/assets/contactCircles.svg'
import { ReactComponent as EasyLaunch } from '@/shared/assets/EasyLaunch.svg'
import blueLines from '@/shared/assets/blueLines.webp'
import redLines from '@/shared/assets/redLines.webp'
import { TextField } from '@/shared/ui/TextField/TextField'
import { Button } from '@/shared/ui/Button/Button'

import cls from './ContactForm.module.scss'
import { useCookies } from 'react-cookie'
import { PhoneNumberField } from '@/shared/ui/PhoneNumberField/PhoneNumberField'
import axios from 'axios'
import Modal from '@/shared/ui/Modal/Modal'
import { classNames } from '@/shared/lib/utils/classNames'

export const ContactForm = () => {
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [nameValid, setNameValid] = useState(true)
    const [emailValid, setEmailValid] = useState(true)
    const [phoneValid, setPhoneValid] = useState(true)
    const [open, setOpen] = useState(false)
    const [cookie, setCookie] = useCookies(['cookie'])

    const phoneHandler = (value) => {
        setPhone(value)
        setPhoneValid(validatePhone(value))
    }
    const validatePhone = (phone) => {
        const regex = /^\d{4,17}$/
        return regex.test(phone)
    }

    const isValidEmail = (email) => {
        setEmail(email)
        setCookie('email', email, { expires: new Date(Date.now() + 900000) })
        let regEmail =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if (!regEmail.test(email) && email.trim() !== '') {
            setEmailValid(false)
        } else {
            setEmailValid(true)
        }
    }
    const nameHandler = (name) => {
        setName(name)
        setCookie('name', name, { expires: new Date(Date.now() + 900000) })

        if (name?.trim() !== '') {
            setNameValid(true)
        }
    }

    const onSubmit = () => {
        name?.trim() === '' ? setNameValid(false) : setNameValid(true)
        emailValid || phone?.trim() === '' ? setEmailValid(false) : setEmailValid(true)
        phone?.trim() === '' ? setPhoneValid(false) : setPhoneValid(true)

        let address = 'https://stellar-softs.com/api/stellarbets/contact'
        if (emailValid && nameValid && phoneValid && email?.trim() && name?.trim() && phone?.trim()) {
            const response = axios
                .post(address, {
                    email: email,
                    name: name,
                    phone: String(phone),
                })
                .then((response) => {
                    console.log(response)
                    setOpen(true)
                    setEmailValid(true)
                })
                .catch((error) => {})
        } else {
            console.log('wrong')
        }
    }

    useEffect(() => {
        setName(String(cookie?.name) == 'undefined' ? '' : String(cookie?.name))
        isValidEmail(String(cookie?.email) == 'undefined' ? '' : String(cookie?.email))
        // setPhone(cookie?.phone ?? '')
        console.log(cookie)
    }, [])

    return (
        <div className={cls.wrapper}>
            <section
                id="contact"
                className={cls.ContactForm}
            >
                <aside className={cls.title}>
                    <h1>Contact us</h1>
                    <div className={cls.mailText}>
                        <Mail className={cls.mailIcon} />
                        <p>distributors@stellar-bets.com</p>
                    </div>
                    <div className={cls.siteText}>
                        <Globe className={cls.globeIcon} />
                        <p>www.7-stellar.com</p>
                    </div>
                </aside>
                <div className={cls.form}>
                    <div className={cls.fields}>
                        <TextField
                            value={name}
                            setValue={nameHandler}
                            placeholder={'Name'}
                            withValidation
                            valid={nameValid}
                        />
                        <TextField
                            value={email}
                            setValue={isValidEmail}
                            placeholder={'E-mail Address'}
                            withValidation
                            valid={emailValid}
                        />
                    </div>

                    <PhoneNumberField
                        phone={phone}
                        phoneHandler={phoneHandler}
                        valid={phoneValid}
                    />
                    <Button
                        className={classNames(cls.submitButton, [], {
                            [cls.disabled]:
                                !emailValid ||
                                !phoneValid ||
                                !nameValid ||
                                !email?.trim() ||
                                !name?.trim() ||
                                !phone?.trim(),
                        })}
                        variant="primary"
                        onClick={() => onSubmit()}
                    >
                        Contact Us
                    </Button>
                </div>
                <Circles className={cls.circles} />
                <div className={cls.border} />
            </section>

            <img
                src={blueLines}
                className={cls.blueLines}
                alt=""
            />
            <img
                src={redLines}
                className={cls.redLines}
                alt=""
            />
            <Modal
                isOpen={open}
                setOpen={setOpen}
            >
                <div className={cls.successMessage}>
                    <EasyLaunch className={cls.icon} />
                    <p>Your message has been{'\n'} successfully sent!</p>
                </div>
            </Modal>
        </div>
    )
}
